import React from 'react';
import { StyleSheet, View } from 'react-native';
import AppText from './AppText';
import { ALPHA_WHITE, DARK_GRAY } from '../../styles/appColor';
import FontAwesome6 from 'react-native-vector-icons/FontAwesome6';
import { match } from 'ts-pattern';

export type ImagesCounterProps = {
  imagesCount: number;
  position: 'top-left' | 'top-right';
};

export function ImagesCounter({ imagesCount, position }: ImagesCounterProps) {
  if (imagesCount <= 1) {
    return <></>;
  }

  return (
    <View
      style={[
        styles.container,
        match(position)
          .with('top-left', () => styles.topLeft)
          .with('top-right', () => styles.topRight)
          .exhaustive(),
      ]}
    >
      <AppText style={styles.text}>+{imagesCount - 1}</AppText>
      <FontAwesome6 name="image" size={12} color={DARK_GRAY} />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    position: 'absolute',
    backgroundColor: ALPHA_WHITE,
    borderRadius: 1000,
    width: 40,
    height: 40,
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 4,
  },
  topLeft: {
    top: 10,
    left: 10,
  },
  topRight: {
    top: 10,
    right: 10,
  },
  text: {
    textAlign: 'center',
    color: DARK_GRAY,
  },
});
